import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { CommentEditorSource } from '../../../CommentEditor/redux/types';
import { CommentEditorProviders, } from '../../../CommentEditor/context';
import CommentBoxRoot from '../../lego/CommentBoxRoot';
/**
 * A skeleton of our CommentBox that includes the `<CommentEditorProviders />`
 * and some customizable view slots that change visibility based on the comment editor state.
 */
var CommentBoxSkeleton = React.forwardRef(function (_a, ref) {
    var id = _a.id, loggedOutView = _a.loggedOutView, editorView = _a.editorView, cantPostView = _a.cantPostView, editComment = _a.editComment, replyComment = _a.replyComment, isSmall = _a.isSmall, _b = _a.canPostComment, canPostComment = _b === void 0 ? true : _b, className = _a.className, rest = __rest(_a, ["id", "loggedOutView", "editorView", "cantPostView", "editComment", "replyComment", "isSmall", "canPostComment", "className"]);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    return (React.createElement(CommentEditorProviders, __assign({ commentBoxId: id, editorSource: editComment
            ? CommentEditorSource.Edit
            : replyComment
                ? CommentEditorSource.Reply
                : CommentEditorSource.Independent, relevantComment: editComment || replyComment }, rest),
        React.createElement(CommentBoxRoot, { className: className, isSmall: isSmall, ref: ref },
            !isLoggedIn && loggedOutView,
            isLoggedIn && (canPostComment ? editorView : cantPostView))));
});
CommentBoxSkeleton.displayName = 'CommentBoxSkeleton';
export default CommentBoxSkeleton;
//# sourceMappingURL=CommentBoxSkeleton.js.map